import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const TABS = [
  { to: '/', label: 'Home', d: 'M3 11l9-8 9 8v10a1 1 0 01-1 1h-5v-6H9v6H4a1 1 0 01-1-1z' },
  { to: '/nfl', label: 'NFL', d: 'M5.5 18.5c-2.5-2.5-2-9 2-13s10.5-4.5 13-2 2 9-2 13-10.5 4.5-13 2zM8 16l8-8M10 12l1 1M12 10l1 1M14 8l1 1' },
  { to: '/college', label: 'CFB', d: 'M2 9l10-5 10 5-10 5zM6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5M22 9v6' },
  { to: '#tools', label: 'Tools', d: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z' },
  { to: '/ask', label: 'Ask', d: 'M4 5h16v10H8l-4 4z' },
];

const TOOLS: [string, string, string][] = [
  ['Predict', '/predict', 'Winner, margin and why'],
  ['Betting', '/betting', 'Where the market is wrong'],
  ['Grades', '/grades', 'Every coaching call graded'],
  ['Breakdown', '/breakdown', 'What decided a finished game'],
];

/** A solid dock pinned to the bottom edge, with a sheet for the four tools. */
export function MobileTabs() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => { setOpen(false); }, [pathname]);
  const toolActive = ['/predict', '/betting', '/grades', '/breakdown', '/coach', '/trends'].some((p) => pathname.startsWith(p));
  const idx = toolActive ? 3 : Math.max(0, TABS.findIndex((t) => (t.to === '/' ? pathname === '/' : pathname.startsWith(t.to))));

  return (
    <>
      {open && <button className="fixed inset-0 z-40 bg-ink/45 md:hidden" onClick={() => setOpen(false)} aria-label="Close tools" />}
      <nav className="fixed inset-x-0 bottom-0 z-50 border-t-2 border-ink bg-paper md:hidden" aria-label="Sections">
        {open && (
          <div className="grid grid-cols-2 gap-px border-b border-line bg-line animate-fadeIn">
            {TOOLS.map(([label, to, sub]) => (
              <Link key={to} to={to} className="bg-paper px-4 py-3">
                <p className="font-display text-[16px] font-bold leading-tight">{label}</p>
                <p className="text-[12px] leading-snug text-muted">{sub}</p>
              </Link>
            ))}
          </div>
        )}
        <div className="flex h-16 pb-[env(safe-area-inset-bottom,0px)]">
          {TABS.map((t, i) => {
            const on = i === idx;
            const cls = `relative flex flex-1 flex-col items-center justify-center gap-1 ${on ? 'text-blue' : 'text-muted'}`;
            const icon = (
              <>
                {/* the active section is marked by a bar on the top edge, like a tab */}
                <span className={`absolute inset-x-3 top-0 h-[3px] ${on ? 'bg-blue' : 'bg-transparent'}`} aria-hidden="true" />
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={t.d} /></svg>
                <span className="font-cond text-[12px] font-semibold uppercase tracking-[0.06em]">{t.label}</span>
              </>
            );
            if (t.to === '#tools') {
              return <button key={t.to} onClick={() => setOpen(!open)} className={cls} aria-expanded={open}>{icon}</button>;
            }
            return <NavLink key={t.to} to={t.to} end={t.to === '/'} className={cls}>{icon}</NavLink>;
          })}
        </div>
      </nav>
    </>
  );
}
